import { createComponent } from '@ycos/fela'

export const SECTION_SPACER_LAYOUT_VARIANT = ['isc-section-spacer', 'isc-section-spacer-half', 'isc-section-spacer-quarter', 'isc-section-spacer-24', 'isc-section-spacer-8-16', 'isc-section-spacer-40-64', 'isc-section-spacer-80-152', 'isc-section-spacer-16-40']

const SectionSpacer = createComponent(
  'SectionSpacer',
  ({ item, theme }) => {
    const defaultMultiplier = 8
    const multiplier = {
      'isc-section-spacer': defaultMultiplier,
      'isc-section-spacer-half': defaultMultiplier / 2,
      'isc-section-spacer-quarter': defaultMultiplier / 4,
      'isc-section-spacer-24': 3,
      'isc-section-spacer-8-16': 1,
      'isc-section-spacer-40-64': 5,
      'isc-section-spacer-16-40': 2,
      'isc-section-spacer-80-152': 10
    }[item.layoutVariant] || defaultMultiplier

    const mediumMultiplier = {
      'isc-section-spacer-8-16': 2,
      'isc-section-spacer-40-64': 8,
      'isc-section-spacer-80-152': 19,
      'isc-section-spacer-16-40': 5
    }[item.layoutVariant] || multiplier

    return {
      border: 'none',
      paddingTop: `${multiplier * theme.spacingMultiplier}px`,
      margin: 0,
      'screen-medium': {
        paddingTop: `${mediumMultiplier * theme.spacingMultiplier}px`
      }
    }
  },
  'hr'
)

SectionSpacer.layoutVariant = SECTION_SPACER_LAYOUT_VARIANT

export default SectionSpacer
